// src/firebase.js
// Replace these values with your Firebase project config
// Get them from: Firebase Console > Project Settings > Your Apps > SDK setup
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBDPZGHZ_BjVZ1LmDzYAtfYKycacTzQg3c",
  authDomain: "saleshub-24331.firebaseapp.com",
  projectId: "saleshub-24331",
  storageBucket: "saleshub-24331.firebasestorage.app",
  messagingSenderId: "1036997711188",
  appId: "1:1036997711188:web:414717c40a7bb20dc124c1"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
